var _defs, _clipPath, _path;
var _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var SvgEye = function SvgEye(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 391.9 234.7",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 0h391.9v234.7H0z"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    overflow: "visible"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M195.5.6C120.8.6 53.1 41.5 3.1 107.9c-4.1 5.4-4.1 13 0 18.5 50 66.5 117.8 107.4 192.5 107.4s142.5-40.9 192.5-107.3c4.1-5.4 4.1-13 0-18.5C338 41.5 270.3.6 195.5.6zm5.4 198.7c-49.6 3.1-90.6-37.8-87.4-87.4 2.6-41 35.8-74.2 76.7-76.7 49.6-3.1 90.6 37.8 87.4 87.4-2.6 40.8-35.8 74-76.7 76.7zm-2.5-37.9c-26.7 1.7-48.8-20.3-47-47 1.4-22.1 19.3-39.9 41.4-41.4 26.7-1.7 48.8 20.3 47 47-1.5 22.2-19.4 40-41.4 41.4zm0 0",
    clipPath: "url(#b)"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEye, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/eye.bc8fcccd.svg";
export { ForwardRef as ReactComponent };